/* ============================================================
   HYPEST — Sticky add-to-cart (mobiel)  ·  TAAK #5
   ------------------------------------------------------------
   Niet-brekend gedrag:
     - Dupliceert GEEN form-/cart-logica. De sticky-knop is een
       dunne proxy: bij klik triggert hij de ECHTE koopknop
       (`.product-form__submit`) via .click(). Alle Wonder-logica
       (variant-validatie, AJAX-cart, error-states) blijft intact.
     - Verschijnt pas wanneer de echte koopknop UIT beeld scrollt
       (IntersectionObserver). Verdwijnt weer zodra die in beeld is.
     - Spiegelt productnaam, prijs en de disabled/sold-out-staat
       van de echte knop, zodat de balk altijd klopt met de variant.
     - Werkt alleen wanneer er een echte koopknop bestaat; anders
       no-op (faalt stil, breekt niets).

   Markup wordt server-side gerenderd door het `sticky_atc`-blok in
   sections/main-product.liquid. Dit script verbindt die markup met
   de bestaande product-form.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-hypest-sticky-atc]');
    if (!bar) return;

    // De ECHTE koopknop binnen de PDP (Wonder rendert deze in het
    // buy_buttons-blok). Zonder echte knop: niets te proxien.
    var realButton = document.querySelector('.product-form__submit, .js-add-to-cart, button[name="add"]');
    var proxyButton = bar.querySelector('[data-hypest-sticky-atc-button]');
    var priceTarget = bar.querySelector('[data-hypest-sticky-atc-price]');
    if (!realButton || !proxyButton) return;

    // ---- 1. Klik-proxy: stuur door naar de echte knop. ----
    proxyButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (realButton.disabled) return;
      // Echte knop afvuren -> Wonder's product-form handelt alles af.
      realButton.click();
    });

    // ---- 2. Disabled/sold-out spiegelen vanaf de echte knop. ----
    function syncDisabled() {
      var isDisabled = realButton.disabled;
      proxyButton.disabled = isDisabled;
      proxyButton.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      // Label volgt de echte knop (Add to cart / Sold out / ...).
      var realLabel = realButton.querySelector('span');
      var proxyLabel = proxyButton.querySelector('[data-hypest-sticky-atc-label]');
      if (realLabel && proxyLabel) {
        var text = (realLabel.textContent || '').trim();
        if (text) proxyLabel.textContent = text;
      }
    }

    // ---- 3. Prijs spiegelen vanaf het price-blok van de PDP. ----
    // We lezen de live-gerenderde prijs (incl. variant-updates die
    // Wonder doet) uit het bestaande price-blok i.p.v. zelf te rekenen.
    function syncPrice() {
      if (!priceTarget) return;
      var source =
        document.querySelector('[id^="price-"] .price__sale .price-item--sale') ||
        document.querySelector('[id^="price-"] .price-item--regular') ||
        document.querySelector('[id^="price-"] .price-item') ||
        document.querySelector('.wt-product__price .price-item');
      if (source) {
        var text = (source.textContent || '').trim();
        if (text) priceTarget.textContent = text;
      }
    }

    // Observeer wijzigingen aan de echte knop (variant-switch zet
    // disabled aan/uit) en aan het price-blok (variant-prijs update).
    var moButton = new MutationObserver(function () {
      syncDisabled();
    });
    moButton.observe(realButton, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      subtree: true,
    });

    var priceBlock = document.querySelector('[id^="price-"]') ||
      document.querySelector('.wt-product__price');
    if (priceBlock) {
      var moPrice = new MutationObserver(function () {
        syncPrice();
      });
      moPrice.observe(priceBlock, { childList: true, subtree: true, characterData: true });
    }

    // ---- 4. Zichtbaarheid via IntersectionObserver. ----
    // Toon de balk zodra de echte koopknop NIET meer zichtbaar is
    // (de bezoeker is voorbij de normale ATC gescrold).
    function syncStickyPad() {
      var visible = bar.classList.contains('is-visible');
      var h = visible ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      document.documentElement.classList.toggle('hypest-sticky-atc-pad', visible);
      document.documentElement.style.setProperty('--hypest-sticky-atc-h', (h || 72) + 'px');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('is-visible');
            } else {
              bar.classList.add('is-visible');
            }
            syncStickyPad();
          });
        },
        {
          // Extra bottom margin: show sticky only when buy button is clearly gone,
          // so size chips near ATC stay usable longer.
          root: null,
          rootMargin: '0px 0px -64px 0px',
          threshold: 0,
        }
      );
      io.observe(realButton);
    }

    // Keep pad in sync if class flips elsewhere.
    var moVis = new MutationObserver(syncStickyPad);
    moVis.observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', syncStickyPad, { passive: true });

    // Eerste sync.
    syncDisabled();
    syncPrice();
    syncStickyPad();
  }

  function start() {
    // Mobile-only + idle: cheap win for DCL/TBT on Meta in-app.
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { init(); }, { timeout: 1200 });
    } else {
      setTimeout(init, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
